<template>
  <div class="px-20">
    <ul class="save-list">
        <li class="save-item" v-if="prepaidCard.thumbnailImageUrl">
            <div class="save-item-left">
              <img :src="prepaidCard.thumbnailImageUrl" :alt="prepaidCard.thumbnailImageDesc" />
            </div>
            <div class="save-item-right">
                <div class="save-item-birth">
                    <span>{{prepaidCard.prepaidCardNickName}}</span>
                    <button v-if="prepaidCard.representative && prepaidCard.status === 'ACTIVATION'" class="icon-star"></button>
                    <button v-else-if="!prepaidCard.representative && prepaidCard.status === 'ACTIVATION'" class="icon-star-gray" @click="toggleChangeRepresentativePopup(prepaidCard)"></button>
                </div>
                <div class="save-item-price">
                    <strong>{{prepaidCard.remainCash | comma}}</strong>
                    <div>
                        <span>구매일<em>{{prepaidCard.issueDate}}</em></span>
                    </div>
                </div>
            </div>
        </li>
    </ul>
    <ul class="usage-button-list">
      <li><button :class="{'focus' : selectPeriod === '1month'}" @click.prevent="selectPeriod = '1month'">1개월</button></li>
      <li><button :class="{'focus' : selectPeriod === '3month'}" @click.prevent="selectPeriod = '3month'">3개월</button></li>
      <li><button :class="{'focus' : selectPeriod === '6month'}" @click.prevent="selectPeriod = '6month'">6개월</button></li>
      <li><button :class="{'focus' : selectPeriod === 'select'}" @click.prevent="selectPeriod = 'select'">기간조회</button></li>
    </ul>
    <div class="usage-date-box" v-if="selectPeriod==='select'">
      <input type="date" name="firstDate" v-model="startDate" data-placeholder="시작일" @change="validPeriod" required/>
      <input type="date" name="lastDate" v-model="lastDate" data-placeholder="종료일" @change="validPeriod" required/>
      <button @click.prevent="searchPeriod">검색</button>
    </div>
    <div class="usage-gray-box">
        <div>
            <span>총 사용 금액</span>
            <em>{{redeemSum | comma}}</em>
        </div>
    </div>
    <use-history :list-data="useListData"></use-history>
    <alert-popup v-if="alertPopupShow" :message="alertMessage" @confirmPopupClickConfirm="alertPopupShow = false"></alert-popup>
    <change-representative-popup
        v-if="showChangeRepresentativePopup"
        :card-name="cardName"
        v-on:toggleChangeRepresentativePopup="toggleChangeRepresentativePopup"
        v-on:changeRepresentativeCard="changeRepresentativeCard"
    />
    <pagination
        :totalRows="useListTotalRow"
        :pageModel="pageModel"
        v-on:movePage="movePage"
    />
  </div>
</template>

<script>
import UseHistory from '@/components/common/UseHistory.vue';
import dayjs from "dayjs";
import apiList from "@/api/apiList";
import AlertPopup from "@/views/myemarticon/alertPopup";
import ChangeRepresentativePopup from "@/views/myemarticon/changeRepresentativePopup";
import Pagination from "@/components/common/Pagination";
export default {
  name: 'UsageDetail',
  components: { UseHistory, AlertPopup, ChangeRepresentativePopup, Pagination },
  data () {
      return {
        selectPeriod: '1month',
        startDate: dayjs().subtract(1, 'month').format('YYYY-MM-DD'),
        lastDate: dayjs().format('YYYY-MM-DD'),
        redeemSum: 0,
        prepaidCardNo: '',
        prepaidCard: {
          thumbnailImageUrl: '',
          thumbnailImageDesc: '',
          prepaidCardNickName: '',
          remainCash: '',
          issueDate: '',
        },
        // 사용내역 데이터
        useListData: [
        ],
        alertMessage: "",
        alertPopupShow: false,
        showChangeRepresentativePopup: false,
        cardName: '',
        pageModel: {
          size: 5,
          pageNo: 1
        },
        useListTotalRow: 0,
      }
  },
  filters: {
    comma(num) {
      return String(num).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
  watch: {
    selectPeriod(value) {
      switch (value) {
        case '1month' :
          this.startDate = dayjs().subtract(1, 'month').format('YYYY-MM-DD');
          this.lastDate = dayjs().format('YYYY-MM-DD');
          break;
        case '3month' :
          this.startDate = dayjs().subtract(3, 'month').format('YYYY-MM-DD');
          this.lastDate = dayjs().format('YYYY-MM-DD');
          break;
        case '6month' :
          this.startDate = dayjs().subtract(6, 'month').format('YYYY-MM-DD');
          this.lastDate = dayjs().format('YYYY-MM-DD');
          break;
        case 'select' :
          this.startDate = dayjs().subtract(7, 'day').format('YYYY-MM-DD');
          this.lastDate = dayjs().format('YYYY-MM-DD');
          break;
        default:
          this.startDate = dayjs().subtract(1, 'month').format('YYYY-MM-DD');
          this.lastDate = dayjs().format('YYYY-MM-DD');
      }
      this.pageModel.pageNo = 1;
      this.useListData = [];
      if(this.prepaidCardNo) {
        this.getPrepaidCardRedeemDetail();
      }
    }
  },
  mounted() {
    this.$heading('사용내역');
    if(this.$route.params.prepaidCardNo) {
      this.prepaidCardNo = this.$route.params.prepaidCardNo;
      this.getPrepaidCard();
      this.getPrepaidCardRedeemDetail();
    }
  },
  methods: {
    async getPrepaidCard() { //TODO : 카드조회 API 이미지 필요
      try{
        const param = {
          prepaidCardNo: this.prepaidCardNo,
          size: 100,
          pageNo: 1
        }
        const response = await apiList.getPrePaidCardBox(param); //카드 보관함 조회
        this.prepaidCard = response.data.data.list[0];
        console.log(this.prepaidCard);
      } catch (error) {
        console.error(error);
      }
    },
    async getPrepaidCardRedeemDetail() {
      try{
        const param = {
          startDate: this.startDate,
          endDate: this.lastDate,
          prepaidCardNo : this.prepaidCardNo,
          size: this.pageModel.size,
          pageNo: this.pageModel.pageNo
        }

        const response = await apiList.getPrepaidRedeemDetail(param);

        this.redeemSum = response.data.data.redeemSum; //총 사용 금액
        this.useListTotalRow =  response.data.data.redeemDetails.totalRows;
        this.prepaidCardRedeemDetailList(response.data.data.redeemDetails.list); //사용내역

      } catch (error) {
        console.error(error);
      }
    },
    prepaidCardRedeemDetailList(list) { //TODO : pos연동 후 매장명으로 변겅
      this.useListData = [];

      for(let data of list) {

        let text = "";

        if(data.purchaseCode === "REFUND") {
          text = "환불";
        } else if(data.purchaseCode === "EXPIRATION") {
          text = "만료";
        } else if(data.voided){
          text = data.merchantName+"[사용취소]";
        } else if(!data.voided) {
          // eslint-disable-next-line no-unused-vars
          text = data.merchantName;
        }

        const param = {
          text: text,
          price: data.voided?"+"+data.redemptionCash:"-"+data.redemptionCash,
          firstDate: dayjs(data.transactionDateTime).format('YYYY/MM/DD'),
          lastDate: dayjs(data.transactionDateTime).format('HH:mm'),
        }

        this.useListData.push(param);
      }
    },
    searchPeriod() {
      if(dayjs(this.lastDate).diff(dayjs(this.startDate), 'day') > 365) {
        this.alertPopupShow = true;
        this.alertMessage = '조회기간은 최대 12개월 입니다.';
        return;
      }

      if(!this.validPeriod()) {
        return;
      }
      this.useListData = [];
      this.pageModel.pageNo = 1;
      this.getPrepaidCardRedeemDetail();
    },
    validPeriod() {
      if(this.startDate > this.lastDate) {
        this.alertPopupShow = true;
        this.alertMessage = '종료일이 시작일보다 이전일 수는 없습니다.';
        return false;
      }
      return true;
    },
    /**
     * 대표카드 변경 팝업 노출
     */
    toggleChangeRepresentativePopup(cardInfo) {
      this.showChangeRepresentativePopup = !this.showChangeRepresentativePopup;
      this.cardName = cardInfo.prepaidCardNickName != null? cardInfo.prepaidCardNickName : cardInfo.giftMessage != null? cardInfo.giftMessage : '이마티콘 카드' //TODO 기본카드명??
      if(this.showChangeRepresentativePopup) {
        this.prepaidCardNo = cardInfo.prepaidCardNo;
      }
    },
    /**
     * 대표카드 변경 API 호출
     */
    async changeRepresentativeCard() {
      try{
        await apiList.putRepresentativeCard({prepaidCardNo: this.prepaidCardNo});
        this.showChangeRepresentativePopup = false;
        this.prepaidCard.representative = true;
      } catch (error) {
        console.error(error);
      }
    },
    movePage(pageNo) {
      this.pageModel.pageNo = pageNo;
      this.getPrepaidCardRedeemDetail();
    }
  }
};
</script>

<style lang="scss" scoped>
	@import '@/assets/styles/pages/myemarticon/usageDetail.scss';
</style>
